import { FC, useState } from "react"
import { TextField, InputAdornment, IconButton, Tooltip } from "@mui/material"
import { Visibility, VisibilityOff, ContentCopy } from "@mui/icons-material"
import { useCopyToClipboard } from "../hooks"

interface IProps {
  label: string
  value: string
  onChange: (value: string) => void
  required?: boolean
  error?: string
  helperText?: string
  fullWidth?: boolean
}

/** Поле формы для секретов: type="password" + toggle-visibility + «скопировать». */
export const SecretField: FC<IProps> = ({
  label,
  value,
  onChange,
  required = false,
  error,
  helperText,
  fullWidth = true,
}) => {
  const [visible, setVisible] = useState(false)
  const { copied, copy } = useCopyToClipboard()

  return (
    <TextField
      label={label + (required ? " *" : "")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth={fullWidth}
      required={required}
      error={!!error}
      helperText={error ?? helperText}
      type={visible ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={copied ? "Скопировано" : "Копировать"}>
              <IconButton size="small" onClick={() => copy(value)} edge="end">
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={visible ? "Скрыть" : "Показать"}>
              <IconButton
                size="small"
                onClick={() => setVisible((v) => !v)}
                edge="end"
              >
                {visible ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  )
}
